import React from 'react';
import PropTypes from 'prop-types';

import image from '../../assets/images/image.svg';
import audio from '../../assets/images/audio.svg';
import video from '../../assets/images/video.svg';
import text from '../../assets/images/text.svg';

import TitleAndAuthor from '../titleAndAuthor/TitleAndAuthor'
import Button from '../button/Button'
import './BookPreviewCard.css'
import mockImage from '../../assets/images/coverSample.jpg';
import failImage from '../../assets/images/coverFail.jpg';
import {isMobile} from "../../utils/device";
import apiAddress from "../../services/api/apiAddress"
import Lottie from 'lottie-react-web';
import loader from '../../assets/images/loader.json';
import {addSlashes} from "../../modules/Functions";

class BookPreviewCard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      imageSrc: '',
      hasError: false
    };

    this.mediaImageURLs = this.parseMediaTypes(props.mediaTypes)
    this.imageContainer = React.createRef();
  }

  parseMediaTypes(mediaTypes) {
    let mediaImageURLs = [];

    for (let mediaType in mediaTypes) {
      switch (mediaTypes[mediaType]) {
        case "image":
          mediaImageURLs.push(image);
          break;
        case "video":
          mediaImageURLs.push(video);
          break;
        case "audio":
          mediaImageURLs.push(audio);
          break;
        case "text":
          mediaImageURLs.push(text);
          break;
        default:
          break;
      }
    }

    return mediaImageURLs;
  }


  componentDidMount() {
    const {coverURL, isbn, alt} = this.props;
    const url = coverURL || `${apiAddress}/api/v1/content/books/media/${isbn}/Images/cover`;

    const image = new Image();
    image.src = url;
    image.onload = () => this.setState({imageUrl: url})
    image.onerror = () => this.setState({hasError: true})
  }

  render() {
    let {
      title,
      author,
      oAuthor,
      description,
      price,
      link,
      animate,
      couponcode
    } = this.props;

    const {imageUrl, hasError} = this.state;

    link = addSlashes(link);

    const cardContainerClass = isMobile ? 'bookPreviewCardContainerMobile' : 'bookPreviewCardContainer';

    const aosProps = (animate && !isMobile) ? {
      "data-aos": "fade-up",
      "data-aos-duration": 1000
    } : {};

    let imageContent;
    if (hasError) {
      imageContent =
        <img src={failImage} alt={title} className="bookPreviewCardLeftSide"
             style={{height: "170px", width: "122px", cursor: "pointer"}}/>;
    } else if (imageUrl) {
      imageContent =
        <img src={imageUrl} alt={title} className="bookPreviewCardLeftSide"
             style={{height: "170px", width: "122px", cursor: "pointer"}}/>;
    } else {
      imageContent = (
        <div style={{width: "20px"}}>
          <Lottie

            options={{
              animationData: loader,
            }}
          />
        </div>
      );
    }

    return (
      <a href={link} style={{textDecoration: "none", outline: "none"}}>
        <div {...aosProps} className={cardContainerClass}>
          <div ref={this.imageContainer}
               style={{height: "170px", width: "122px"}}>
            {imageContent}
          </div>
          <div className="bookPreviewCardRightSide">
            <div className="bookPreviewCardRightSideMainContent">
              <TitleAndAuthor title={title} author={author} oAuthor={oAuthor}
                              onClick={!isMobile ? () => {
                                window.location.href = link
                              } : undefined}/>
              {this.mediaImageURLs.length > 0 &&
                <div className="bookPreviewCardMediaTypesContainer mb-2">
                  {this.mediaImageURLs.map((mediaImageURL, index) => {
                    let fileType = mediaImageURL.split("/").pop().split(".")[0];
                    let mediaType = fileType;
                    switch (fileType) {
                      case "image":
                        mediaType = "Bild";
                        break;
                      case "audio":
                        mediaType = "Audio";
                        break;
                      case "video":
                        mediaType = "Video";
                        break;
                      case "text":
                        mediaType = "Text";
                        break;
                      default:
                        break;
                    }
                    return (
                      <div key={index}>
                        <img alt={mediaType}
                             title={mediaType}
                             src={mediaImageURL}/>
                      </div>
                    );
                  })}
                </div>}
              <div
                className="bookPreviewCardDescription mb-md-2">{description}</div>
            </div>
            {!price && <Button colorScheme="classic" size="small">
              Zum Titel
            </Button>}
            {price && <div>{price}</div>}
            {couponcode &&
              <div className={'bookpreviewcoupon'}>E-Book-Code:<br/>{couponcode}
              </div>}
          </div>
        </div>
      </a>
    );
  }
}

BookPreviewCard.propTypes = {
  title: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  oAuthor: PropTypes.string,
  description: PropTypes.string,
  mediaTypes: PropTypes.arrayOf(PropTypes.string.isRequired),
  coverURL: PropTypes.string
}

export default BookPreviewCard;
